import { useState } from 'react';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { useChat } from '../../chat/ChatProvider';

export default function EmotePickerSheet({ conversationId }) {
  const { state, dispatch, searchPicker, sendSticker, sendGif } = useChat();
  const { picker } = state;
  const [busy, setBusy] = useState(false);

  if (!picker.open) return null;

  const close = () => dispatch({ type: 'PICKER_SET', patch: { open: false } });

  const onPickSticker = async (item) => {
    setBusy(true);
    try {
      await sendSticker(conversationId, {
        stickerId: item.id,
        emoteCode: item.emoteCode,
      });
      close();
    } catch {
      /* keep open */
    } finally {
      setBusy(false);
    }
  };

  const onPickGif = async (item) => {
    setBusy(true);
    try {
      await sendGif(conversationId, {
        gifId: item.id,
        emoteCode: item.emoteCode,
        objectKey: item.objectKey,
      });
      close();
    } catch {
      /* keep open */
    } finally {
      setBusy(false);
    }
  };

  const packs = picker.data?.packs || [];
  const recent = picker.data?.recent || [];
  const searchHits = picker.data?.searchHits || [];

  return (
    <div className="chat-sheet" role="presentation" onClick={close}>
      <div
        className="chat-sheet__panel"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="chat-sheet__header">
          <div className="chat-sheet__tabs">
            <button
              type="button"
              className={picker.tab === 'stickers' ? 'is-active' : ''}
              onClick={() => {
                dispatch({ type: 'PICKER_SET', patch: { tab: 'stickers' } });
                searchPicker('stickers', picker.query);
              }}
            >
              貼圖
            </button>
            <button
              type="button"
              className={picker.tab === 'gifs' ? 'is-active' : ''}
              onClick={() => {
                dispatch({ type: 'PICKER_SET', patch: { tab: 'gifs' } });
                searchPicker('gifs', picker.query);
              }}
            >
              GIF
            </button>
          </div>
          <button type="button" className="chat-link-btn" onClick={close}>
            關閉
          </button>
        </header>
        <input
          className="chat-sheet__search"
          placeholder="搜尋 emote code…"
          value={picker.query || ''}
          onChange={(e) => {
            const q = e.target.value;
            dispatch({ type: 'PICKER_SET', patch: { query: q } });
            searchPicker(picker.tab, q);
          }}
        />
        <div className="chat-sheet__body">
          {picker.loading ? <p className="chat-state">載入中…</p> : null}
          {searchHits.length ? (
            <section>
              <h4>搜尋結果</h4>
              <EmoteGrid
                items={searchHits}
                tab={picker.tab}
                disabled={busy}
                onPick={picker.tab === 'gifs' ? onPickGif : onPickSticker}
              />
            </section>
          ) : null}
          {recent.length ? (
            <section>
              <h4>常用</h4>
              <EmoteGrid
                items={recent}
                tab={picker.tab}
                disabled={busy}
                onPick={picker.tab === 'gifs' ? onPickGif : onPickSticker}
              />
            </section>
          ) : null}
          {packs.map((pack) => (
            <section key={pack.id || pack.packCode || pack.name}>
              <h4>
                {pack.name || 'Pack'}
                {pack.accessType ? ` · ${pack.accessType}` : ''}
              </h4>
              <EmoteGrid
                items={pack.items || []}
                tab={picker.tab}
                disabled={busy}
                onPick={picker.tab === 'gifs' ? onPickGif : onPickSticker}
              />
            </section>
          ))}
          {!picker.loading && !packs.length && !recent.length && !searchHits.length ? (
            <p className="chat-state">沒有可用貼圖／GIF</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function EmoteGrid({ items, tab, onPick, disabled }) {
  return (
    <div className="chat-emote-grid">
      {(items || []).map((item) => {
        const key = item.emoteCode || item.stickerId || item.gifId || item.id;
        const src = resolveMemberMediaUrl(item.mediaUrl || item.objectKey);
        return (
          <button
            key={key}
            type="button"
            className="chat-emote-grid__item"
            disabled={disabled}
            title={item.emoteCode || ''}
            onClick={() => onPick(item)}
          >
            {src ? <img src={src} alt={item.emoteCode || tab} /> : <span>{item.emoteCode || '?'}</span>}
          </button>
        );
      })}
    </div>
  );
}
